import { BaseApi } from './base.api.js';

export class CompetenceApi extends BaseApi {
    constructor(client) {
        super(client, '/competence');
    }
}
